/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useLazyQuery } from '@apollo/client';

export const useAccountSelection = () => {

    const ACCOUNT_SELECTION_GQL = gql`
    query AccountSelection($request: AccountSelectionInput!) {
        accountSelection(request: $request) {
        status
        }
    }
    `;

    const [fetchAccountSelection, accountSelectionData] = useLazyQuery(ACCOUNT_SELECTION_GQL,{
        fetchPolicy: 'network-only',
        context:{
            clientName:"/secure-storage/manage"
        }
      })

    return {fetchAccountSelection, accountSelectionData};
}